/* Olivia Carr — enquiry form.

   Single job: mirror the selected interest's data-tag into the hidden
   contact[Interest Tag] field so enquiries segment automatically.

   The hidden field starts empty on the site-wide form. If JavaScript never
   runs, the tag is absent but contact[Interest] still identifies the enquiry
   exactly — a missing tag is recoverable, a wrong one is not. Nothing here
   ever guesses. */

(function () {
  'use strict';

  var selects = document.querySelectorAll('[data-interest-select]');

  Array.prototype.forEach.call(selects, function (select) {
    var form = select.form;
    if (!form) return;

    var hidden = form.querySelector('[data-interest-tag]');
    /* Contact page only — the other presets ask their own narrower question
       instead and don't carry these elements. Each is optional on its own;
       a missing target is not an error, the rest of sync() still runs. */
    var help = form.querySelector('[data-interest-help]');
    var orgField = form.querySelector('[data-org-field]');
    var orgLabelText = form.querySelector('[data-org-label-text]');
    var orgIndicator = form.querySelector('[data-org-indicator]');
    var orgInput = orgField && orgField.querySelector('input');
    var roleField = form.querySelector('[data-role-field]');
    var roleIndicator = form.querySelector('[data-role-indicator]');
    var roleInput = roleField && roleField.querySelector('input');

    /* Organisation and Role default to visible and optional — the same
       state the markup already renders with no option selected. Every
       piece of this reads from the chosen <option>'s data attributes, so a
       browser that never runs this script simply keeps that safe default:
       nothing is silently required, nothing silently disappears. */
    function setRequired(indicatorEl, inputEl, isRequired) {
      if (!indicatorEl || !inputEl) return;
      inputEl.required = isRequired;
      indicatorEl.textContent = isRequired ? 'Required' : 'Optional';
      indicatorEl.classList.toggle('form__optional', !isRequired);
      indicatorEl.classList.toggle('form__required', isRequired);
    }

    function sync() {
      var option = select.options[select.selectedIndex];

      if (hidden) {
        hidden.value = (option && option.getAttribute('data-tag')) || '';
      }

      if (help) {
        var text = (option && option.getAttribute('data-help')) || '';
        if (text) {
          help.textContent = text;
          help.hidden = false;
        } else {
          help.textContent = '';
          help.hidden = true;
        }
      }

      if (orgField || roleField) {
        var hideOrgRole = !!(option && option.getAttribute('data-hide-org-role') === 'true');

        if (orgField) orgField.hidden = hideOrgRole;
        if (roleField) roleField.hidden = hideOrgRole;

        if (hideOrgRole) {
          /* Hidden fields must not block submission or send a stale value. */
          if (orgInput) { orgInput.required = false; orgInput.value = ''; }
          if (roleInput) { roleInput.required = false; roleInput.value = ''; }
        } else {
          var orgLabel = (option && option.getAttribute('data-org-label')) || 'Organisation / company';
          var orgRequired = !!(option && option.getAttribute('data-org-required') === 'true');
          var roleRequired = !!(option && option.getAttribute('data-role-required') === 'true');

          if (orgLabelText) orgLabelText.textContent = orgLabel;
          setRequired(orgIndicator, orgInput, orgRequired);
          setRequired(roleIndicator, roleInput, roleRequired);
        }
      }
    }

    if (!hidden && !help && !orgField && !roleField) return;

    select.addEventListener('change', sync);
    sync(); // covers a browser restoring a previous selection on back-navigation
  });

  /* SELF MADE — speaking form only.

     The reveal itself is CSS, so this script is not responsible for showing the
     quantity. Its only job is the payload: whenever the box is unticked the
     quantity is reset and disabled, so a visitor who ticks, chooses "51–100",
     then changes their mind cannot leave a stale number in the email. The
     checkbox needs no handling — an unticked checkbox is never submitted.

     If this never runs, the reveal still works and the enquiry still sends. */
  Array.prototype.forEach.call(
    document.querySelectorAll('[data-book-toggle]'),
    function (toggle) {
      var wrap = toggle.closest('.form__book');
      var qty = wrap && wrap.querySelector('[data-book-qty] select');
      if (!qty) return;

      function sync() {
        if (toggle.checked) {
          qty.disabled = false;
        } else {
          qty.value = '';
          qty.disabled = true;
        }
      }

      toggle.addEventListener('change', sync);
      sync(); // also covers a browser restoring state on back-navigation
    }
  );

  /* Shopify's notification email lists every contact[*] field it receives,
     including empty ones — so an untouched optional field arrives as a blank
     line. Disabling an empty optional field on submit keeps it out of the
     payload entirely, and out of the email.

     Only fields explicitly marked data-drop-if-empty are ever dropped. The
     interest select, the hidden interest tag and every required field are not
     marked and cannot be affected. If this script never runs, nothing is
     dropped and the form behaves exactly as before — tidiness degrades,
     correctness does not. */
  Array.prototype.forEach.call(document.querySelectorAll('form'), function (form) {
    form.addEventListener('submit', function () {
      var optional = form.querySelectorAll('[data-drop-if-empty]');

      Array.prototype.forEach.call(optional, function (field) {
        if (field.name === 'contact[Interest]' || field.hasAttribute('data-interest-tag')) {
          return; // belt and braces: never drop a tagging field
        }
        if (field.required) return;
        if (String(field.value).trim() === '') field.disabled = true;
      });

      /* If navigation is blocked for any reason, put them back so the form
         stays usable rather than silently losing its optional fields. */
      window.setTimeout(function () {
        Array.prototype.forEach.call(optional, function (field) {
          field.disabled = false;
        });
      }, 1000);
    });
  });

  /* A CTA carrying data-interest pre-selects the matching option in the form it
     scrolls to, and fires change so the hidden tag stays in sync. Matching is
     exact against the option value, never fuzzy: a wrong pre-selection is worse
     than none, because the enquirer will not notice it was set for them. */
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[data-interest]');
    if (!link) return;

    var href = link.getAttribute('href') || '';
    if (href.charAt(0) !== '#') return;

    var target = document.getElementById(href.slice(1));
    if (!target) return;

    /* Two different selects depending on the form. The site-wide contact form
       has the tagged interest select; a preset page (Organisations, Brands,
       Speaking) locks its tag and asks the narrower engagement-type question
       instead, which is the one these CTAs name. Prefer the engagement select,
       fall back to the interest one. */
    var select =
      target.querySelector('#enquiry-sub') ||
      target.querySelector('[data-interest-select]');
    if (!select) return;

    var wanted = link.getAttribute('data-interest');
    for (var i = 0; i < select.options.length; i++) {
      if (select.options[i].value === wanted) {
        select.selectedIndex = i;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        break;
      }
    }
  });

  /* Arriving from another page with ?interest= in the URL. A journalist
     following "Press & media" in the footer lands on the contact form with
     Media / Podcast / Interview already chosen, rather than hunting a dropdown
     for the one option that applies to them. Exact match only, same as the
     click path: a wrong pre-selection is worse than none. */
  (function () {
    var m = /[?&]interest=([^&#]+)/.exec(window.location.search);
    if (!m) return;

    var wanted = decodeURIComponent(m[1].replace(/\+/g, ' '));
    var select =
      document.querySelector('[data-interest-select]') ||
      document.querySelector('#enquiry-sub');
    if (!select) return;

    for (var i = 0; i < select.options.length; i++) {
      if (select.options[i].value === wanted) {
        select.selectedIndex = i;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        break;
      }
    }
  })();

  /* Move focus to the confirmation or the error summary after a submission, so
     a screen reader announces the outcome instead of silently reloading. */
  var announce =
    document.querySelector('[data-form-success]') ||
    document.querySelector('.form__errors');

  if (announce) announce.focus();
})();
